"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStyleMap = createStyleMap;

var _theme = _interopRequireDefault(require("./theme"));

var _utils = require("../../utils");

function createStyleMap() {
  for (var _len = arguments.length, maps = new Array(_len), _key = 0; _key < _len; _key++) {
    maps[_key] = arguments[_key];
  }

  return _utils.immutableDeepMerge.apply(void 0, [_theme["default"]].concat(maps));
}
//# sourceMappingURL=styleMap.js.map